import { useState, useCallback } from 'react'
import styled from 'styled-components'

import { format } from 'utils'

import Invalid from './Invalid'

const Input = (props) => {
  const [isActive, setActive] = useState(false)

  const {
    name,
    label,
    value = '',
    tag,
    disabled = false,
    pattern,
    charPattern,
    isNumber,
    limit = 900000,
    onChange = () => {},
    invalid,
    type = 'text',
  } = props

  const onActive = useCallback(() => setActive(true), [])
  const onInactive = useCallback(() => setActive(false), [])
  const onValue = (evt) => {
    if (onChange) {
      let val = evt.target.value
      if (pattern) {
        val = format.clearPattern(val, charPattern)
      }

      if (isNumber && val !== '') {
        const tmp = +val
        val = tmp === 0 || tmp ? val : value
      }

      if (val.length <= limit) {
        onChange(val, name, tag)
      }
    }
  }

  const text = pattern ? format.toPattern(value, pattern) : value + ''
  const invalidCss = invalid ? ' invalid' : ''
  const activeCss = isActive ? ' active' : ''
  const disableCss = disabled ? ' disabled' : ''

  return (
    <Content
      className={`${invalidCss}${activeCss}${disableCss}`}
      style={props.containerStyled}
    >
      {props.rightComponent}
      <InputValue
        id={name}
        className={`${invalidCss}${activeCss}${disableCss}`}
        placeholder={label}
        type={type}
        autoComplete="off"
        required
        disabled={disabled}
        value={text}
        onChange={onValue}
        onFocus={onActive}
        onBlur={onInactive}
        style={props.inputStyled}
      />

      <Invalid invalid={invalid} />
    </Content>
  )
}

const Content = styled.div`
  width: 100%;
  height: 56px;
  background-color: #f7f8f9;
  border-radius: 8px;
  padding: 0px 10px;
  border: 1px solid ${(p) => p.theme.input.border};
  display: flex;

  &.active {
    border: 1px solid ${(p) => p.theme.input.activeBorder};
  }

  &.disabled {
    background-color: ${(p) => p.theme.input.disable};
  }

  &.invalid {
    border: 1px solid ${(p) => p.theme.color.error};
  }
`

const InputValue = styled.input`
  width: 100%;
  height: 96%;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${(p) => p.theme.input.color};
  background-color: #f7f8f9;
  border: none;
  outline: none;

  &::placeholder {
    color: black;
    opacity: 0.6;
  }

  &::disabled {
    background-color: ${(p) => p.theme.input.disable};
  }

  &::-webkit-autofill,
  &::-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0 1000px #fff inset;
    -webkit-text-fill-color: #1e6af6;
  }
`

export default Input
